import { Navigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { SwitchBlock } from "../components/league/SwitchBlock.jsx";
import { useGetUserLeagues } from "../api/leaguesApi.js";
import { useAuth } from "../hooks/useAuth";
import { Spinner } from "../components/common/Spinner";
import { buildLoginRedirectPath } from "../components/routing/loginRedirect";

function LeagueSwitchPage() {
  const { session, user, loading } = useAuth();
  const location = useLocation();

  const isAuthenticated = !!session && !!user;
  const shouldFetch = isAuthenticated;

  const { data: userLeagues, refetch, isLoading, error } = useGetUserLeagues(shouldFetch);
  const [leagues, setLeagues] = useState([]);

  useEffect(() => {
    if (userLeagues) {
      setLeagues(userLeagues);
    }
  }, [userLeagues]);

  // Handle loading states
  if (loading || (shouldFetch && isLoading)) {
    return (
      <div className="page-league join-page">
        <div className="wrapper">
          <div className="loader">
            <Spinner />
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={buildLoginRedirectPath(location)} replace />;
  }

  return (
    <div className="page-league join-page">
      <div className="wrapper">
        <div className="title-block">
          <h1>SWITCH LEAGUE</h1>
        </div>
        {error ? (
          <div className="error-message">
            Failed to load leagues. Please try again.
          </div>
        ) : leagues.length === 0 ? (
          <div className="empty-message">No other leagues to switch to.</div>
        ) : (
          <SwitchBlock leagues={leagues} />
        )}
      </div>
    </div>
  );
}

export { LeagueSwitchPage };
